import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PowerPlayerFeatureIndicator } from '../components/messageBoxes/settingsModal/powerPlayerFeatureIndicator';
export const GameGuidePowerPlayerFeatureIndicator = ({ label }) => {
    return (_jsx("div", { children: _jsx(PowerPlayerFeatureIndicator, { isClickable: true, label: label }) }));
};
